"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOrthographicCameraSize = setOrthographicCameraSize;
function setOrthographicCameraSize(camera, width, height) {
  var params = {
    left: width / -2,
    right: width / 2,
    top: height / 2,
    bottom: height / -2
  };
  Object.assign(camera, params);
}